// src/auth/acl.js

// Khóa quyền chuẩn toàn app
export const PERMS = {
    ADMIN: "admin",
    USERS: "users.manage",
    SERVICES: "services.manage",
    POSTS: "posts.manage",
    DRUM_LESSONS: "drum_lessons",
    NOTIFICATIONS: "notifications.view",
};

// helper
export const hasAny = (perms = [], need = []) => {
    // quyền trống -> ai cũng thấy
    if (!need?.length) return true;
    // admin luôn thấy tất cả
    if (perms.includes(PERMS.ADMIN)) return true;
    // cần khớp ít nhất 1 quyền
    return need.some((p) => perms.includes(p));
};

export const isAdmin = (perms = []) => perms.includes(PERMS.ADMIN);

// Menu cấu hình 1 chỗ
export const MENU = [
    { key: "me", label: "Cá nhân", to: "/ca-nhan", rights: [] },
    { key: "post", label: "Đăng tin", to: "/dang-tin", rights: [] },

    // ⛔ Tổng quan: CHỈ admin mới thấy
    { key: "overview", label: "Tổng quan", to: "/admin", rights: [PERMS.ADMIN] },

    // Quản trị
    { key: "services", label: "Quản lý dịch vụ", to: "/admin/services", rights: [PERMS.SERVICES, PERMS.ADMIN] },
    { key: "users", label: "Quản lý user", to: "/admin/users", rights: [PERMS.ADMIN] },
    { key: "maint", label: "🛠️ Bảo trì hệ thống", to: "/admin/maintenance", rights: [PERMS.ADMIN] },
    { key: "posts", label: "Quản lý tin đăng", to: "/admin/posts", rights: [PERMS.POSTS, PERMS.ADMIN] },
    { key: "drum_lessons", label: "Trống lục lạc", to: "/admin/drum-lessons", rights: [PERMS.ADMIN, PERMS.DRUM_LESSONS] },

    // Thông báo (chỉ user có quyền mới thấy)
    { key: "notifications", label: "Thông báo", to: "/thong-bao", rights: [PERMS.ADMIN, PERMS.NOTIFICATIONS] },

    { key: "logout", label: "Đăng xuất", to: "/logout", rights: [] },
];

// Route guard map
export const ROUTES = [
    // Public (nếu bạn muốn /dang-tin yêu cầu đăng nhập/quyền thì bổ sung quyền ở đây)
    { path: "/dang-tin", rights: [] },

    // ⛔ Trang admin root: CHỈ admin
    { path: "/admin", rights: [PERMS.ADMIN] },
    { path: "/admin/services", rights: [PERMS.SERVICES, PERMS.ADMIN] },
    { path: "/admin/users", rights: [PERMS.ADMIN] },
    { path: "/admin/posts", rights: [PERMS.POSTS, PERMS.ADMIN] },
    { path: "/admin/maintenance", rights: [PERMS.ADMIN] },
    { path: "/admin/drum-lessons", rights: [PERMS.ADMIN, PERMS.DRUM_LESSONS] },

    // Thông báo (cần quyền)
    { path: "/thong-bao", rights: [PERMS.ADMIN, PERMS.NOTIFICATIONS] },
];
